import { put, takeLatest, call } from 'redux-saga/effects';
import { GET_CHALLENGES, GET_MY_COHORTS } from './constants';
import {
  getChallengesSuccess,
  getChallengesError,
  getMyCohortsSuccess,
  getMyCohortsError,
} from './actions';
import { fetchData } from '../api';

export function* getChallenges() {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/challenges`;
    const token = window.localStorage.token;
    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };

    // GET /api/challenges returns { challenges: [...] } (each enriched with
    // its cohorts + live memberCount). Store just the array.
    const response = yield call(fetchData, url, config);
    yield put(getChallengesSuccess(response.challenges || []));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(getChallengesError(error));
  }
}

export function* getMyCohorts() {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/cohorts/mine`;
    const token = window.localStorage.token;
    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };

    // GET /api/cohorts/mine returns { cohorts: [...] } — each cohort joined
    // with the caller's membership + daysUntilStart + phase.
    const response = yield call(fetchData, url, config);
    yield put(getMyCohortsSuccess(response.cohorts || []));
  } catch (err) {
    console.log(err);
    const error = yield err.json().catch(() => ({}));
    yield put(getMyCohortsError(error));
  }
}

export default function* challengeSaga() {
  yield takeLatest(GET_CHALLENGES, getChallenges);
  yield takeLatest(GET_MY_COHORTS, getMyCohorts);
}
